<template>
  <panel :heading="label">
    <license-code />
  </panel>
</template>
<script>
import LicenseCode from '@components/singletons/licenseCode';
import Panel from '@components/singletons/panel';

export default {
  components: { LicenseCode, Panel },
  props: {
    label: {
      type: String,
      default: '',
    },
  },
};
</script>
